module.exports = __webpack_public_path__ + "img/what_are_gears.d29020c5.png";